var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style["mds-popover"],
        _vm.classObject,
        _vm.positionClass,
        _vm.widthClass,
        _vm.sizeClass,
      ],
      attrs: {
        role: "tooltip",
        "aria-hidden": _vm.ariaHidden,
        "data-mds-version": _vm.version,
      },
    },
    [
      _c(
        "div",
        { class: _vm.$style["mds-popover__content"] },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }